import { sprintf } from '@splunk/ui-utils/format';
import { _ } from '@splunk/ui-utils/i18n';

const MODAL_HEADER_TEXT = _('Delete %(itemName)s');
export const modalHeaderText = (itemName: string) =>
    sprintf(MODAL_HEADER_TEXT, { itemName });

const MODAL_BODY_TEXT = _(
    '%(itemName)s is currently being used by %(usageConjunction)s'
);
export const modalBodyText = ({
    itemName,
    usageConjunction,
}: {
    itemName: string;
    usageConjunction: string;
}) => sprintf(MODAL_BODY_TEXT, { itemName, usageConjunction });

const ITEM_USAGE_TEXT = _('%(usedCount)d %(usedByType)s');
export const itemUsageText = ({
    usedCount,
    usedByType,
}: {
    usedCount: number;
    usedByType: string;
}) => sprintf(ITEM_USAGE_TEXT, { usedCount, usedByType });

const CONFIRMATION_TEXT = _(
    'Are you sure you want to delete this %(itemType)s?'
);
export const confirmationText = (itemType: string) =>
    sprintf(CONFIRMATION_TEXT, { itemType });

export const DEFAULT_ITEM_TYPE = _('item');
